export const LogoMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M10 26a32 32 0 0 1 44 0" fill="none" stroke="#1f8bff" strokeWidth="6" strokeLinecap="round" />
    <path d="M19 35a19 19 0 0 1 26 0" fill="none" stroke="#1f8bff" strokeWidth="6" strokeLinecap="round" />
    <path d="M24 44l8 12 8-12" fill="none" stroke="#0b2a8a" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <a href="#beranda" data-testid="site-logo" className="flex flex-col items-center leading-none group">
    <LogoMark className="w-8 h-6 -mb-1 transition-transform duration-500 group-hover:-translate-y-0.5" />
    <span className={`font-display font-extrabold tracking-tight text-[26px] sm:text-[30px] ${light ? "text-white" : "text-vnavy"}`}>
      VISION
    </span>
    <span className={`text-[9px] sm:text-[10px] font-bold tracking-[0.32em] mt-0.5 ${light ? "text-sky-300" : "text-vblue"}`}>
      MEGA NETWORK
    </span>
  </a>
);
